import { createContext, Dispatch, SetStateAction, useContext } from 'react';

interface ServiceContractBillingValue {
  allSelected: boolean;
  setAllSelected: Dispatch<SetStateAction<boolean>>;
  numberOfServiceContractsToProcess: number;
  setNumberOfServiceContractsToProcess: Dispatch<SetStateAction<number>>;
}

const Context = createContext<ServiceContractBillingValue>(null);

export const ServiceContractBillingContextProvider = Context.Provider;

export function useServiceContractBillingContext(): ServiceContractBillingValue {
  const context = useContext(Context);

  if (context === null) {
    throw new Error(
      'useServiceContractBillingContext must be used within a <ServiceContractBillingContextProvider>'
    );
  }

  return context;
}
